import { Component } from "react";
import { compose } from "redux";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import SMSTemplates from "./SMSTemplates.Component";
import { templatesConnector } from "../../../services/templates/connector";

import PropTypes from "prop-types";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

class TemplatesComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { activeTab: 0 };
  }

  handleChangeTab = (event, newValue) => this.setState({ activeTab: newValue });

  componentDidMount() {
    this.props.getSMSTemplates();
  }

  render() {
    return (
      <div className="templates-layout body-height">
        <Tabs onChange={this.handleChangeTab} value={this.state.activeTab}>
          <Tab label="SMS Templates" />
          <Tab label="Other templates" />
        </Tabs>
        {this.state.activeTab === 0 && (
          <div className="content-padding">
            <SMSTemplates
              setTemplate={this.props.setSMSTemplate}
              smsTemplates={this.props.smsTemplates.data}
            />
          </div>
        )}
        {this.state.activeTab === 1 && (
          <div className="content-padding">TODO content here</div>
        )}
      </div>
    );
  }

  static propTypes = {
    smsTemplates: PropTypes.object.isRequired,
    setSMSTemplate: PropTypes.func.isRequired,
    getSMSTemplates: PropTypes.func.isRequired,
  };
}
export default compose(templatesConnector)(TemplatesComponent);
